export default __webpack_public_path__ + "static/media/cohort-small-blue.5f01c7a4.svg";